import { render } from "./ManoSauronView.vue?vue&type=template&id=b90aed70"
import script from "./ManoSauronView.vue?vue&type=script&lang=js"
export * from "./ManoSauronView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__